import Skeleton from './skeleton';
import SkeletonItem from '../skeleton-item';

/* istanbul ignore next */
Skeleton.install = function(Vue) {
  Vue.component(Skeleton.name, Skeleton);
  Vue.component(SkeletonItem.name, SkeletonItem);
};

export default Skeleton;
